import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet, useSearchParams } from 'react-router-dom';
import { useAuthRedirect } from '@/hooks/useAuthRedirect.ts';
import Middleware from '@/router/middleware/index.tsx';

const NotLoggedIn: FC = () => {
  const { session } = useAuthContext();
  const { redirectPath, isResolving } = useAuthRedirect();
  const [searchParams] = useSearchParams();

  const getRedirectPath = () => {
    const returnUrl = searchParams.get('returnUrl');
    if (returnUrl && returnUrl.startsWith('/')) {
      return returnUrl;
    }
    return redirectPath;
  };

  return <Middleware isLoading={isResolving}>{!session ? <Outlet /> : <Navigate to={getRedirectPath()} />}</Middleware>;
};

export default NotLoggedIn;
